export default __webpack_public_path__ + "static/media/Shreyash Pant.7b772637.jpg";